/* eslint-disable react-native/no-inline-styles */
import type { CardTextProps } from '@Components/BigBrowse/GridCardMesh/Components/Texts/CardText';
import { HtmlText } from '@Components/BigBrowse/GridCardMesh/Components/Texts/HtmlText';
import { convertToHtmlTextProps } from '@Components/BigBrowse/GridCardMesh/Components/Texts/texts.common';
import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import {
  PRODUCT_SUBTITLE_TEXT,
  PRODUCT_SUBTITLE_TEXT_MOBILE,
} from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/shelf/common/shelfDisplay.figma';
import { observer } from 'mobx-react-lite';

import { TextPositioner } from '../primitives/TextPositioner';

type Props = {
  item: GridCard<PlaneTypes.Card_MultiSection_Subtitle>;
};

export const ProductSubtitle = observer(function ProductSubtitle({
  item,
}: Props) {
  const fontProps =
    item.data?.layout === 'full'
      ? PRODUCT_SUBTITLE_TEXT
      : PRODUCT_SUBTITLE_TEXT_MOBILE;

  const paddingLeft = item.data?.layout === 'full' ? 10 : 5;

  const getTextProps = (): CardTextProps =>
    convertToHtmlTextProps({
      text: item.data?.title ?? '',
      ...fontProps,
      color: item.data?.style?.color,
    });

  return (
    <TextPositioner item={item}>
      <HtmlText {...getTextProps()} size={item.size} style={{ paddingLeft }} />
    </TextPositioner>
  );
});
